export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10188.69a1cb51.jpg";